'use strict';

var _regeneratorRuntime = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _asyncToGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var multipartRequest = require('ipfs-core-utils/multipart-request');

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var abortSignal = require('../lib/abort-signal.js');

var nativeAbortController = require('native-abort-controller');

var createPut = configure.configure(function (api) {
  function put(_x) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var options,
          controller,
          signal,
          res,
          response,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              controller = new nativeAbortController.AbortController();
              signal = abortSignal.abortSignal(controller.signal, options.signal);
              _context.prev = 3;
              _context.t0 = api;
              _context.t1 = _objectSpread;
              _context.t2 = {
                signal: signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(options)
              };
              _context.next = 9;
              return multipartRequest.multipartRequest([data], controller, options.headers);

            case 9:
              _context.t3 = _context.sent;
              _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
              _context.next = 13;
              return _context.t0.post.call(_context.t0, 'block/put', _context.t4);

            case 13:
              response = _context.sent;
              _context.next = 16;
              return response.json();

            case 16:
              res = _context.sent;
              _context.next = 28;
              break;

            case 19:
              _context.prev = 19;
              _context.t5 = _context["catch"](3);

              if (!(options.format === 'dag-pb')) {
                _context.next = 25;
                break;
              }

              return _context.abrupt("return", put(data, _objectSpread(_objectSpread({}, options), {}, {
                format: 'protobuf'
              })));

            case 25:
              if (!(options.format === 'dag-cbor')) {
                _context.next = 27;
                break;
              }

              return _context.abrupt("return", put(data, _objectSpread(_objectSpread({}, options), {}, {
                format: 'cbor'
              })));

            case 27:
              throw _context.t5;

            case 28:
              return _context.abrupt("return", cid.CID.parse(res.Key));

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 19]]);
    }));
    return _put.apply(this, arguments);
  }

  return put;
});
exports.createPut = createPut;